import { Component, Input, OnInit } from '@angular/core';
import { SecurityGroupSecurityModel } from 'src/app/core/models/security-model/security-group-security.model';
import { ActionService } from 'src/app/core/utils/action.service';
import { AttributeSearchConditionView } from '../shared/view/attribute-search-condition.view';

@Component({
    selector: 'op-attribute-tabs',
    templateUrl: './attribute-tabs.component.html'
})
export class AttributeTabsComponent implements OnInit {
    @Input() selectedTab: string;
    @Input() userSecurity: SecurityGroupSecurityModel;
    @Input() searchCondition: AttributeSearchConditionView = null;

    constructor(private actionService: ActionService) { }

    ngOnInit(): void {
        this.addAction(this.selectedTab);
    }

    onActiveIdChange(activeId: string) {
        this.addAction(activeId);
    }

    addAction(actionCode: string) {
        if (actionCode != 'CATEGORY') {
            this.actionService.add(actionCode, null, null);
        } 
    }

}
